export default __webpack_public_path__ + "4d84ca8e7f9cd836464f063bd3eea268.png";